export default {
	salesForm: {
		header: "It's easy to get started",
		subheader:
			'Get a a personalized demo and help you find the perfect plan for your team.',
	},
	formId: {
		enterprisePricing: 'b33fb63e-dbf2-436c-ac27-b3266b1a58cd',
		professionalPricing: '021366df-69c7-40fb-80f4-c672cd2304d3',
		starterPricing: 'd859003c-0387-4768-abf2-576d5e101cbe',
		volunteerPricing: '28b50466-15e1-4221-972a-0eb8b7283ff7',
		givingPricing: '79d8920a-61c7-452d-a304-f1ece36333ea',
		salesForm: 'b99cf398-dc03-4b39-9c94-15fda49771d7',
	},
	siteVariable: {
		descriptionHero: 'Hero form with description',
		gatedHero: 'Hero gated form',
		footerForm: 'Footer Form',
	},
	buttonText: {
		quote: 'Get a Quote',
		meeting: 'Book a Meeting',
		learn: 'Learn More',
		report: 'Get the Report',
	},
	formSelects: {
		role: [
			'Director',
			'Manager',
			'Executive',
			'Technology or Operations',
			'Programs or Projects ',
			'Other',
			'Grantseeker',
		],
		organizationType: [
			'Foundation',
			'Corporation',
			'Government',
			'Nonprofit',
			'Public Institution',
			'Other',
		],
		programType: [
			'Grantmaking',
			'Public Funds Distribution',
			'Corporate Social Responsibility',
			'Volunteer',
			'Scholarship or Fellowship',
			'Award',
			'Publishing',
			'Other application process',
			"I'm looking to apply or submit.",
		],
	},
	wistiaIds: {
		nextZenDemo: '2ptcg4zxze',
		legacyGovDemo: 'cer4o0n1xr',
		csrDemo: 'i0c0zjdjle',
		// foundationsDemo: '85b8sn6uj3',
		// generalDemo: 'kectnmi4i6',
		meetSubmittable: 'kahcffdfte', // on: submission-management-software
		meetSubmittableNoGate: 'g360czr25d', // on: CLPs
	},
	socialLinks: {
		facebook: 'https://www.facebook.com/submittable/',
		twitter: 'https://twitter.com/submittable/',
		instagram: 'https://www.instagram.com/submittable/',
		youtube: 'https://www.youtube.com/channel/UCSZnPvsIW2heYmWezip3Q-g',
		linkedIn: 'https://www.linkedin.com/company/submittable/',
	},
	legacyDemoVideoGovChapters: {
		sections: [
			{
				title: 'Launch',
				description:
					'Create a great applicant experience and launch your program fast.',
				timeStamps: {
					stamp: 44,
					start: '0:44',
					end: '4:48',
				},
			},
			{
				title: 'Manage',
				description:
					'Communicate, collaborate, and review all in one platform.',
				timeStamps: {
					stamp: 285,
					start: '4:45',
					end: '7:19',
				},
			},
			{
				title: 'Award',
				description:
					'Track, reimburse, and distribute funds with easy-to-use dashboards and simple, secure workflows.',
				timeStamps: {
					stamp: 440,
					start: '7:20',
					end: '8:17',
				},
			},
			{
				title: 'Closeout',
				description:
					'Create robust reports to ensure you meet your goals and are compliant.',
				timeStamps: {
					stamp: 499,
					start: '8:19',
					end: '10:22',
				},
			},
		],
	},
	nextZenDemoVideoChapters: {
		sections: [
			{
				title: 'Applicant/Awardee Experience',
				description:
					'Create a great applicant and awardee experience in one easy-to-use portal.',
				timeStamps: {
					stamp: 40,
					start: '0:40',
					end: '3:47',
				},
			},
			{
				title: 'Reviewer Experience',
				description:
					'Communicate, collaborate, and review everything all in one place.',
				timeStamps: {
					stamp: 228,
					start: '3:48',
					end: '5:12',
				},
			},
			{
				title: 'Administrator Experience',
				description:
					'Launch your programs, award funds, and manage post-award activities with simple reporting to keep your programs on track and compliant.',
				timeStamps: {
					stamp: 313,
					start: '5:12',
					end: '11:28',
				},
			},
		],
	},
	demoVideoCorpChapters: {
		sections: [
			{
				title: 'Inspire',
				description: 'Activate champions with hands-on volunteer experiences.',
				timeStamps: {
					stamp: 53,
					start: '0:53',
					end: '1:37',
				},
			},
			{
				title: 'Empower',
				description: 'Drive up participation with an easy, modern solution.',
				timeStamps: {
					stamp: 98,
					start: '1:38',
					end: '4:07',
				},
			},
			{
				title: 'Amplify',
				description:
					'Extend your impact with a best-in-class grant management platform.',
				timeStamps: {
					stamp: 248,
					start: '4:08',
					end: '5:23',
				},
			},
			{
				title: 'Measure',
				description: 'Know your ROI and tell the story of your impact.',
				timeStamps: {
					stamp: 324,
					start: '5:24',
					end: '6:18',
				},
			},
		],
	},
	helpTopics: {
		generalHelp: [
			{
				text: 'Getting Started',
				link: 'http://submittable.help/en/collections/2090544-submittable-quick-start-guide',
			},
			{
				text: 'Build Your Program',
				link: 'http://submittable.help/en/collections/3957060-build-your-program',
			},
			{
				text: 'Manage Your Process',
				link: 'http://submittable.help/en/collections/3957059-manage-your-processes',
			},
			{
				text: 'Report Your Impact',
				link: 'http://submittable.help/en/collections/3957057-report-on-your-impact',
			},
			{
				text: 'Help For Applicants',
				link: 'http://submittable.help/en/collections/185534-help-for-applicants',
			},
			{
				text: 'Release Notes',
				link: 'http://submittable.help/en/collections/185651-release-notes',
			},
		],
		submitterHelp: [
			{
				text: 'What is the status of my submission?',
				link: 'https://submittable.help/en/articles/907292-how-do-i-check-the-status-of-my-application',
			},
			{
				text: 'How do I create an account?',
				link: 'https://submittable.help/en/articles/923475-why-do-i-need-a-submittable-account-to-make-a-submission',
			},
			{
				text: 'How do I submit?',
				link: 'https://submittable.help/en/articles/904856-how-do-i-submit',
			},
			{
				text: 'How can I contact an organization to which I submitted?',
				link: 'https://submittable.help/en/articles/2576225-how-can-i-communicate-with-an-organization-to-which-i-ve-made-a-submission',
			},
			{
				text: 'How can I view a submission that I’ve made?',
				link: 'https://submittable.help/en/articles/904859-how-can-i-view-a-submission-that-i-ve-made',
			},

			{
				text: 'How can I request an edit to a submission?',
				link: 'https://submittable.help/en/articles/904890-how-can-i-request-an-edit-on-my-submission',
			},
		],
	},
	helpPage: {
		hours: '9am - 5pm MT',
		generalMessage: `Send us a message anytime. Our business hours are 9am - 5pm MT. We aim to respond within 24 business hours.`,
		goldMessage: `Send us a message anytime. Our business hours are 9am - 5pm MT. We aim to respond within 12 business hours.`,
		platinumMessage: `Send us a message anytime. Our business hours are 9am - 5pm MT. We aim to respond within 2 business hours.`,

		phoneNumber: '(855) 467-8264 PIN 725',
		forBilling: 'For billing, account plan, and upgrade questions',
		contactAM: 'Contact our customer success team',
		emailSupport: 'Email Support for Technical Help',
		faqHours: '24 hours a day 7 days a week',
		writeToUs: 'Write to us',
		writeToUsEs: 'Escríbenos',
		centralHours: 'M-F 8am-6pm Central',
		centralHoursEs: 'Lunes-Viernes 8am-6pm Hora Central',
		faqHelpSubjectLinesEnglish: [
			'Eligibility Question',
			'Submission Status',
			'How do I submit?',
			'Do I need to submit?',
			'Sign-in / Password',
			'Saved Draft Reminders',
			'Issues Generating Quiz (KBA)',
			'Issues Completing IDV',
			'Funds Distribution Question',
			'Timeline Question',
			"Can't Find My Address",
			'Questions About Dependents',
			'Questions About Spouses',
			'How Will Awards Be Calculated?',
			'Bank Account Questions',
			'Drivers License Questions',
			'Accessibility Request',
			'Other Questions',
		],
		faqHelpSubjectLinesSpanish: [
			'Pregunta de elegibilidad',
			'Estado de presentación',
			'¿Cómo presento?',
			'¿Necesito enviar?',
			'Inicio de sesión / Contraseña',
			'Recordatorios de borradores guardados',
			'Cuestionario de generación de problemas (KBA)',
			'Problemas para completar IDV',
			'Distribución de Fondos Pregunta',
			'Pregunta de línea de tiempo',
			'No puedo encontrar mi dirección',
			'Preguntas sobre dependientes',
			'Preguntas sobre cónyuges',
			'¿Cómo se calcularán los premios?',
			'Preguntas sobre cuentas bancarias',
			'Preguntas sobre la licencia de conducir',
			'Solicitud de accesibilidad',
			'Otras preguntas',
		],
	},
	menu: {
		topLevel: [
			{ contentful_id: 0, menuSectionTitle: 'Product' },
			{ contentful_id: 1, menuSectionTitle: 'Solutions' },
			{ contentful_id: 2, menuSectionTitle: 'Resources' },
			{
				contentful_id: 3,
				menuSectionTitle: 'Pricing',
				menuSectionLinkLocation: '/pricing',
			},
		],
		productSubLevel: [
			{
				contentful_id: 4,
				menuSectionTitle: 'Overview',
				backgroundColor: '#FC5B30',
			},
			{
				contentful_id: 5,
				menuSectionTitle: 'Government',
				backgroundColor: '#0FB8C6',
			},
			{
				contentful_id: 6,
				menuSectionTitle: 'Foundations',
				backgroundColor: '#EFA20F',
			},
			{
				contentful_id: 6,
				menuSectionTitle: 'Corporations',
				backgroundColor: '#789EE8',
			},
			{
				contentful_id: 7,
				menuSectionTitle: 'Watch a Demo',
				menuSectionLinkLocation: '/demo-video',
			},
		],
	},
	impactStudioConference: {
		registrationPage: 'registration',
		conferencePage: 'conference',
		confirmationPage: 'confirmation',
		episodePage: 'episode',
		links: {
			aboutSection: 'About the conference',
			agendaSection: 'Agenda',
			communitySection: 'Community',
			donateSection: 'Donations',
		},
		anchors: {
			regAboutAnchor: 'registration-about',
			regAgendaAnchor: 'registration-agenda',
			regCommunityAnchor: 'registration-community',
			regDonationAnchor: 'registration-donation',
			confAgendaAnchor: 'conference-agenda',
			confCommunityAnchor: 'conference-community',
			confDonationAnchor: 'conference-donation',
		},
	},
	webinarTypes: {
		live: 'Live/Upcoming',
		onDemandWistia: 'OnDemand via Wistia',
		onDemandOther: 'OnDemand via External Link',
	},
	webinarForm: {
		hubspot: 'Hubspot Form',
		zoom: 'Zoom Registration',
		none: 'None',
	},
};
